import { ThemeProvider } from "styled-components";
import InvoiceGenerator from "./components/InvoiceGenerator";
import GlobalStyles, { ThemeType } from "./styles/Global";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

function App() {
  const theme: ThemeType = {
    colors: {
      primary: "#8bc53f",
      disabled: "#b2b6bd",
      disabledStep: "#f2f2f2",
      disabledStepText: "#b2b6bd",
      accent: "#3c3",
      red: "#fa5252",
    },
  };

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <InvoiceGenerator />
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;